import { BrowserRouter, Routes, Route, Navigate, useOutletContext } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AppShell } from "./components/AppShell";
import ClerkAuthProvider from "./components/auth/ClerkAuthProvider";
import { AdminOnly, Protected } from "./components/auth/Protected";
import Overview from "./pages/Overview";
import StockHolding from "./pages/StockHolding";
import WeeklyReport from "./pages/WeeklyReport";
import Uploads from "./pages/Uploads";
import AdminPage from "./pages/AdminPage";
import { SignInPage, SignUpPage } from "./pages/AuthPages";
import { useTheme } from "./lib/theme";

const AdminRoute = () => {
  const { me } = useOutletContext();
  return <AdminOnly me={me}><AdminPage /></AdminOnly>;
};

function App() {
  const theme = useTheme();
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <Routes>
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
          <Route element={<Protected />}>
            <Route element={<AppShell />}>
              <Route path="/" element={<Overview />} />
              <Route path="/stock" element={<StockHolding />} />
              <Route path="/report" element={<WeeklyReport />} />
              <Route path="/uploads" element={<Uploads />} />
              <Route path="/admin" element={<AdminRoute />} />
              <Route path="/settings" element={<Navigate to="/admin" replace />} />
            </Route>
          </Route>
        </Routes>
      </ClerkAuthProvider>
      <Toaster theme={theme} position="bottom-right" />
    </BrowserRouter>
  );
}

export default App;
